import { style } from '@vanilla-extract/css';

export const labelColumn = style(
  {
    width: '46%',
  },
  'plan-table-label-column',
);
